<template>
  <div class="category">
    <div>
      <el-button size="small" type="primary" @click="handleAdd"
        >添加分组</el-button
      >
    </div>
    <div>
      <el-table :data="boxGroupList" v-loading="loading">
        <el-table-column
          prop="id"
          label="分组ID"
          width="100px"
        ></el-table-column>
        <el-table-column prop="category_id" label="所属分类">
          <template slot-scope="{ row }">{{
            getCategoryName(row.category_id)
          }}</template>
        </el-table-column>
        <el-table-column prop="name" label="分组名称"></el-table-column>
        <el-table-column prop="sort" label="排序"></el-table-column>
        <el-table-column prop="is_show" label="是否显示"></el-table-column>
        <el-table-column label="操作" width="200px">
          <template slot-scope="{ row }">
            <el-button type="primary" plain @click="handleEdit(row)"
              >编辑</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-dialog
      :visible.sync="visibleEdit"
      :title="isEdit ? '编辑分组' : '添加分组'"
      width="400px"
    >
      <el-form
        label-width="80px"
        :model="editForm"
        ref="editForm"
        :rules="rules"
      >
        <el-form-item prop="category_id" label="分组类别">
          <el-select
            v-model="editForm.category_id"
            placeholder="请选择奖品分类"
          >
            <el-option
              v-for="item in categories"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="name" label="分组名称">
          <el-input v-model="editForm.name"></el-input>
        </el-form-item>
        <el-form-item prop="sort" label="分组排序">
          <el-input v-model="editForm.sort"></el-input>
        </el-form-item>
        <el-form-item label="是否显示">
          <el-switch v-model="editForm.is_show"></el-switch>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="visibleEdit = false">取 消</el-button>
        <el-button
          size="small"
          type="primary"
          @click="submit"
          :loading="buttonLoading"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'
import { patchData, postData } from '../../http'
export default {
  data() {
    return {
      editForm: {
        category_id: undefined,
        name: '',
        sort: '',
        is_show: ''
      },
      page: 1,
      editId: undefined,
      loading: false,
      visibleEdit: false,
      buttonLoading: false,
      isEdit: false,
      rules: {
        category_id: [{ required: true, message: '请选择分组类别' }],
        name: [{ required: true, message: '请输入分组名称' }]
      }
    }
  },
  computed: {
    ...mapGetters(['boxGroupList']),
    ...mapState({
      categories: state => state.data.categories
    }),
  },
  methods: {
    ...mapActions(['getBoxGroupList','getCategories']),
    getData() {
      this.loading = true
      this.getBoxGroupList().finally(() => {
        this.loading = false
      })
    },
    handleAdd() {
      this.isEdit = false
      this.editForm.category_id = undefined
      this.editForm.name = ''
      this.editForm.sort = ''
      this.editForm.is_show = true
      this.visibleEdit = true
    },
    handleEdit(row) {
      this.isEdit = true
      this.editForm.category_id = row.category_id
      this.editForm.name = row.name
      this.editForm.sort = row.sort
      this.editForm.is_show = Boolean(row.is_show)
      this.editId = row.id
      this.visibleEdit = true
    },
    handlePageChange() {
      this.getData()
    },
    submit() {
      this.$refs['editForm'].validate(valid => {
        if (valid) {
          this.buttonLoading = true
          if (this.isEdit && this.editId) {
            patchData(`box_groups/${this.editId}`, this.editForm)
              .then(res => {
                this.$message.success('编辑成功')
                this.visibleEdit = false
                this.getData()
              })
              .finally(() => {
                this.buttonLoading = false
              })
          } else {
            postData('box_groups', this.editForm)
              .then(res => {
                this.$message.success('添加成功')
                this.visibleEdit = false
                this.getData()
              })
              .finally(() => {
                this.buttonLoading = false
              })
          }
        }
      })
    },
    getCategoryName(id) {
      //分类中文名称
      if (this.categories) {
        for (let item of this.categories) {
          if (item.id === id) {
            return item.name
          }
        }
      } else {
        return ''
      }
    },
  },
  created() {
    this.getData()
    !this.categories && this.getCategories()
  }
}
</script>

<style>
</style>
